module.exports = __webpack_public_path__ + "static/media/adaptive-icon.73c2f539.png";